import React, { useState } from "react";
import "../Request/Addrequest.css";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { ViewUniqueiddetailsApi, RequestQuerySendApi  } from "../../Config/api";
import { getRegisterId } from "../../Config/userId";
import { toast } from "react-toastify";
const Addrequestdetails = () => {

  const [uniqueId, setUniqueId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [companyName, setCompanyName] = useState("");
    const [senderId, setSenderId] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [registerId, setRegisterId] = useState("");
  const [loading, setLoading] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [staffUniqueId, setStaffUniqueId] = useState(""); 
  const getUserId= getRegisterId();

  const handleUniqueIdFetch = async () => {

  if (!uniqueId || uniqueId.length < 4) return;

  try {
    setLoading(true);

    const res = await ViewUniqueiddetailsApi(`?unique_id=${uniqueId}`);

    console.log(res.data);

    if (
      res.data.status === 200 &&
      res.data.staff_unique_id_details
    ) {

      const data = res.data.staff_unique_id_details;

      setEmployeeName(data.name || "");
      setCompanyName(data.company_name || "");
      setStaffUniqueId(data.staff_unique_id || "");
      setSenderId(data.user_id || "");
      setCompanyId(data.company_id || "");
      setRegisterId(data.id || "");


    } else {
      setEmployeeName("");
      setCompanyName("");
     toast.error("No data found for this Unique ID", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }

  } catch (err) {
    console.error(err);
    setEmployeeName("");
    setCompanyName("");
    toast.error("Invalid Unique ID", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });

  } finally {
    setLoading(false);
  }
};

const handleSendRequest = async (e) => {
 e.preventDefault();
  if (!staffUniqueId) {
    toast.error("Please enter Unique ID", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return;
  }

  if (!requestMessage.trim()) {
   toast.error("Please enter request message", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return;
  }

  try {

    const formData = new FormData();
    formData.append("staff_unique_id", staffUniqueId);
    formData.append("query", requestMessage);
    formData.append("register", registerId);
    formData.append("sender", senderId);
    formData.append("old_company", companyId);
    formData.append("receiver", getUserId);

    await RequestQuerySendApi(formData);

    toast.success("Request sent successfully", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });

    setRequestMessage("");

  } catch (err) {
    console.error(err);
    toast.error("Failed to send request", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
  }
};


  return (
    <div className="index-container">
      <Header />
      <div className="index-content-parent">
        <div className="index-content">
          <Sidebar   />
          <div className="index-content-sub">
            <div className="index-main">
              <div className="pages-subheader">
                <div className="pages-subheader-sub-1">
                  <p>Add Request Details</p>
                </div>
                <div className="pages-line"></div>
              </div>
                <div className="add_request_details_main_div">
                    <div className="add_request_details_main_div_1">
                        <div className="outerbox_design">
                        <div className="add_request_details_main_div_2">
                    <div className="add_request_details_div">
                        <div className="add_request_details_div_1">
                            <label>Unique ID</label>
                             <span className="registeration-mandatory">*</span>
                            
                            <input type="text" placeholder="Unique Id"  value={uniqueId}  onChange={(e) => setUniqueId(e.target.value)} onBlur={handleUniqueIdFetch}  onKeyDown={(e) => { if (e.key === "Enter") { handleUniqueIdFetch();}}}/>
                            
                        </div>
                         <div className="add_request_details_div_1">
                            <label>Employee Name</label>
                            <input type="text"  value={employeeName} readOnly/>
                        </div>
                         <div className="add_request_details_div_1">
                            <label>Company Name</label>
                            <input type="text" value={companyName} readOnly/>
                        </div>
                    </div>
                   
                    <div className="add_request_text_msg">
                        <div className="add_request_text_msg_area">
                            <label>Request Message</label>
                            <textarea type="text"  value={requestMessage} onChange={(e) => setRequestMessage(e.target.value)}/>
                        </div>
                    </div>
                    <div className="request_send_btn">
                        <button type="button" onClick={handleSendRequest}>Send</button>
                    </div>
                     </div>
                     </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addrequestdetails;
